module.exports = __webpack_public_path__ + "static/scale-model-of-milwaukee-county-zoo-in-milwaukee-wisconsin-ae2bd7780912ef4e047755fb01094531.png";